import React, { useState } from 'react';

const DriverHandbookLog = () => {
  const initialEntries = Array.from({ length: 15 }, (_, i) => ({
    id: i + 1,
    driverName: '',
    received: null,
    signed: null,
    date: '',
    managerSign: '',
    driverSign: '',
  }));

  const [entries, setEntries] = useState(initialEntries);

  const handleChange = (id, field, value) => {
    setEntries(entries.map(e => e.id === id ? { ...e, [field]: value } : e));
  };

  const renderYesNoCheckbox = (id, field, value) => (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <input
          type="checkbox"
          checked={value === true}
          onChange={() => handleChange(id, field, true)}
        />
        <span>Y</span>
      </label>
      <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <input
          type="checkbox"
          checked={value === false}
          onChange={() => handleChange(id, field, false)}
        />
        <span>N</span>
      </label>
    </div>
  );

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="printable-form" id="driver-handbook-log" style={{ padding: '1rem', backgroundColor: '#fff' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>Driver Handbook Log</h2>
      <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '1.5rem' }}>
        Record of drivers receiving and signing the handbook
      </p>

      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '0.85rem',
          pageBreakInside: 'auto',
        }}
      >
        <thead>
          <tr>
            <th style={headerCellStyle}>Driver Name</th>
            <th style={headerCellStyle}>Handbook Received</th>
            <th style={headerCellStyle}>Signed</th>
            <th style={headerCellStyle}>Date</th>
            <th style={headerCellStyle}>Manager Signature</th>
            <th style={headerCellStyle}>Driver Signature</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(({ id, driverName, received, signed, date, managerSign, driverSign }) => (
            <tr key={id} style={{ pageBreakInside: 'avoid' }}>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={driverName}
                  onChange={(e) => handleChange(id, 'driverName', e.target.value)}
                  placeholder="Driver name"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>{renderYesNoCheckbox(id, 'received', received)}</td>
              <td style={cellStyle}>{renderYesNoCheckbox(id, 'signed', signed)}</td>
              <td style={cellStyle}>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => handleChange(id, 'date', e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={managerSign}
                  onChange={(e) => handleChange(id, 'managerSign', e.target.value)}
                  placeholder="Manager sign"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={driverSign}
                  onChange={(e) => handleChange(id, 'driverSign', e.target.value)}
                  placeholder="Driver sign"
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
        <button
          onClick={handlePrint}
          style={{
            backgroundColor: '#2563eb',
            color: 'white',
            padding: '0.5rem 1.25rem',
            borderRadius: '0.375rem',
            cursor: 'pointer',
            border: 'none',
            fontWeight: 'bold',
          }}
        >
          Print Driver Handbook Log
        </button>
      </div>

      {/* Print CSS to hide everything except this form when printing */}
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #driver-handbook-log, #driver-handbook-log * {
            visibility: visible;
          }
          #driver-handbook-log {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            font-size: 12pt;
          }
          button {
            display: none !important;
          }
          @page {
            size: A4 Landscape;
            margin: 15mm;
          }
        }
      `}</style>
    </div>
  );
};

const headerCellStyle = {
  border: '1px solid #999',
  padding: '0.25rem 0.5rem',
  backgroundColor: '#f3f4f6',
  textAlign: 'center',
};

const cellStyle = {
  border: '1px solid #999',
  padding: '0.15rem 0.5rem',
  verticalAlign: 'middle',
  textAlign: 'center',
};

const inputStyle = {
  width: '100%',
  padding: '0.15rem 0.3rem',
  fontSize: '0.85rem',
  boxSizing: 'border-box',
};

export default DriverHandbookLog;
